/* Skinny Genie redesign: homepage-only carousels (hero, bestsellers, category
   carousel, cafe photo carousel). Ported as-is from the approved mockup. */

function scrollBestsellers(dir){
  var track = document.getElementById('bestsellers-track');
  if(!track) return;
  var card = track.querySelector('.bs-card');
  var step = card ? card.getBoundingClientRect().width + 26 : 300;
  track.scrollBy({left: dir * step, behavior: 'smooth'});
}
function updateHomeBsArrows(){
  var track = document.getElementById('bestsellers-track');
  var prev = document.getElementById('home-bs-prev');
  var next = document.getElementById('home-bs-next');
  if(!track || !prev || !next) return;
  prev.classList.toggle('disabled', track.scrollLeft <= 4);
  next.classList.toggle('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
}

function scrollHomeCategories(dir){
  var track = document.getElementById('home-cat-track');
  if(track){ track.scrollBy({left: dir * 360, behavior: 'smooth'}); }
}
function updateHomeCatArrows(){
  var track = document.getElementById('home-cat-track');
  var prev = document.getElementById('home-cat-prev');
  var next = document.getElementById('home-cat-next');
  if(!track || !prev || !next) return;
  prev.classList.toggle('disabled', track.scrollLeft <= 4);
  next.classList.toggle('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
}

var cafeCarouselIndex = 0;
function stepCafeCarousel(dir){
  var carousel = document.getElementById('cafe-carousel');
  if(!carousel) return;
  var slides = carousel.querySelectorAll('.cafe-carousel-slide');
  if(!slides.length) return;
  slides[cafeCarouselIndex].classList.remove('active');
  cafeCarouselIndex = (cafeCarouselIndex + dir + slides.length) % slides.length;
  slides[cafeCarouselIndex].classList.add('active');
  updateCafeCarouselArrows(slides.length);
}
function updateCafeCarouselArrows(slideCount){
  ['home-cafe-prev', 'home-cafe-prev-m'].forEach(function(id){
    var btn = document.getElementById(id);
    if(btn){ btn.classList.toggle('disabled', cafeCarouselIndex === 0); }
  });
  ['home-cafe-next', 'home-cafe-next-m'].forEach(function(id){
    var btn = document.getElementById(id);
    if(btn){ btn.classList.toggle('disabled', cafeCarouselIndex === slideCount - 1); }
  });
}

var heroCarouselIndex = 0;
var heroCarouselTimer = null;
function goToHeroSlide(i){
  var hero = document.querySelector('.home-hero');
  if(!hero) return;
  var slides = hero.querySelectorAll('.home-hero-slide');
  var dots = hero.querySelectorAll('.home-hero-dot');
  if(!slides.length) return;
  slides[heroCarouselIndex].classList.remove('active');
  dots[heroCarouselIndex] && dots[heroCarouselIndex].classList.remove('active');
  heroCarouselIndex = (i + slides.length) % slides.length;
  slides[heroCarouselIndex].classList.add('active');
  dots[heroCarouselIndex] && dots[heroCarouselIndex].classList.add('active');
  resetHeroCarouselTimer();
}
function resetHeroCarouselTimer(){
  if(heroCarouselTimer) clearInterval(heroCarouselTimer);
  var hero = document.querySelector('.home-hero');
  if(!hero) return;
  var count = hero.querySelectorAll('.home-hero-slide').length;
  if(count < 2) return;
  heroCarouselTimer = setInterval(function(){ goToHeroSlide(heroCarouselIndex + 1); }, 6000);
}

document.addEventListener('DOMContentLoaded', function(){
  var bsTrack = document.getElementById('bestsellers-track');
  if(bsTrack){ bsTrack.addEventListener('scroll', updateHomeBsArrows); updateHomeBsArrows(); }

  var catTrack = document.getElementById('home-cat-track');
  if(catTrack){ catTrack.addEventListener('scroll', updateHomeCatArrows); updateHomeCatArrows(); }

  var cafeCarousel = document.getElementById('cafe-carousel');
  if(cafeCarousel){ updateCafeCarouselArrows(cafeCarousel.querySelectorAll('.cafe-carousel-slide').length); }

  resetHeroCarouselTimer();
});
